<template>
  <div class="auth">
    <div class="auth-container">
      <div class="auth-wrapper">
        <p class="auth-title">Registration</p>
        <primary-input type="text"
                       name="template name"
                       class="email-input"
                       placeholder="Enter template name" />
        <div class="auth-nav-container">
            <button @click="$router.push({name: 'reseller-mail-template-template'})"
                class="primary-button">Register</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue")
  },
  data: () => ({
  }),
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .auth-container {
    margin-top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .auth-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 340px;
      width: 540px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      padding: 60px;
      margin: 150px auto;
      .auth-title {
        color: #000000;
        font-family: ""Helvetica Neue"";
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }
      .email-input {
        margin-bottom: 20px;
      }
      .auth-nav-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        button {
          width: 90px;
          height: 40px;
        }
      }
    }
  }
}
</style>

